/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Settings_Categories_EmptyInputs */

const en_cases_settings_categories_empty = /** @type {(inputs: Cases_Settings_Categories_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No categories yet.`)
};

/**
* | output |
* | --- |
* | "No categories yet." |
*
* @param {Cases_Settings_Categories_EmptyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const cases_settings_categories_empty = /** @type {((inputs?: Cases_Settings_Categories_EmptyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Settings_Categories_EmptyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cases_settings_categories_empty(inputs)
});